module.exports = __webpack_public_path__ + "img/Cycling-Road.a7899fa6.png";